import { Button } from "src/components";
import crossIcon from "../../assets/cross.svg";
import { setPriorityInvoice } from "src/services/invoice-api";
import { useToast } from "src/hooks/useToast";
import { useState } from "react";
import { useEventStatus } from "src/hooks/useEventStatus";
import { useSelector } from "react-redux";
import { RootState } from "src/context/store";

const InvoiceSetPriority = ({
  onCloseModal,
  invoiceData,
  unset,
  tab,
}: {
  onCloseModal: () => void;
  invoiceData: any;
  unset?: boolean;
  company_code?: any[];
  division_code?: any[];
  startDate?: Date | string;
  endDate?: Date | string;
  assignee_id?: any[];
  city?: any[];
  district?: any[];
  state?: any[];
  ordering?: any[];
  status?: any[];
  tab?: string;
}) => {
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);
  const { InvoiceFilters, InvoiceApprovalFilters } = useSelector((state: RootState) => state.invoice);
  const { withEventCheck } = useEventStatus();

  const company_code = tab == "entry" ? InvoiceFilters?.company?.[0]?.code : InvoiceApprovalFilters?.company?.[0]?.code;

  const handleSetPriority = async () => {
    setIsLoading(true);
    const payload = {
      data: {
        stockist_invoice_attachment_id: invoiceData?.stockist_invoice_attachment_id,
        unset: unset,
      },
      primary_key: invoiceData?.stockist_invoice_attachment_id,
      event_type: "STOCKIST_ATTACHMENT_PRIORITISE",
    };
    try {
      const res = await setPriorityInvoice(payload, company_code);
      const invoiceStatusUpdateResponse = await withEventCheck(
        async () => {
          // const params = {
          //   company_code: company_code?.map((item) => item.code)?.join(",") || "",
          //   division_code: division_code?.map((item) => item.company_divisioncode)?.join(",") || "",
          //   startDate: startDate,
          //   endDate: endDate,
          //   assignee_id: assignee_id?.map((item) => item.invoice_assignment_id)?.join(",") || "",
          //   city: city?.map((item) => item.city_name?.split("|")?.[0]?.trim())?.join(",") || "",
          //   district: district?.map((item) => item.district_name)?.join(",") || "",
          //   state: state?.map((item) => item.state_name)?.join(",") || "",
          //   ordering: ordering?.[0]?.key || "DESC",
          //   fuid_status_id: status?.map((item) => item.fuid_status_id)?.join(",") || (tab === "approval" ? "6,8" : "1"),
          //   screen: tab === "approval" ? "Approval" : "Entry",
          //   page_size: 10,
          //   page_number: 1,
          // };
          // const allInvoicesRes = await fetchInvoicesData(params);
          // if (tab === "approval") {
          //   dispatch(invoiceActions.setInvoiceApprovalList(allInvoicesRes?.data?.data?.invoiceData || []));
          // } else {
          //   dispatch(invoiceActions.setInvoiceData(allInvoicesRes?.data?.data?.invoiceData || []));
          // }
          // // navigate("/transactions/invoice/0")
          setIsLoading(false)
        },
        res?.data?.data?.eventStreamCreated?.streamId
      );
      toast({ description: "Invoice priority set successfully", variant: "default" });
      console.log(invoiceStatusUpdateResponse)
      onCloseModal();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      onCloseModal();
    }
  };

  return (
    <div className="flex flex-col gap-y-2 w-[500px] mx-auto bg-white p-4 border border-gray-300 shadow-lg rounded-lg">
      <div className="flex justify-between items-center">
        <p className="text-normal py-1 font-semibold text-[#1B1A1F]">{unset ? "Remove Priority" : "Set Priority"}</p>
        <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
          <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
        </Button>
      </div>
      <p className="text-sm mb-2 font-normal text-[#666666]">Are you sure you want to {unset ? "remove priority" : "set priority"} this invoice?</p>

      <div className="flex justify-end gap-x-2">
        <Button disabled={isLoading} isLoading={isLoading} loaderSize="small" className="text-white bg-[#8051FF] mt-4" onClick={handleSetPriority}>
          Proceed
        </Button>
        <Button disabled={isLoading} className="bg-[#f5f5f5]  mt-4" onClick={onCloseModal}>
          Cancel
        </Button>
      </div>
    </div>
  );
};

export default InvoiceSetPriority;
